import { memo, useState } from 'react'

import ResultsTable from '../../ResultsTable'
import Active from '../../commons/Active'
import Inactive from '../../commons/Inactive'
import TableCell from '../../commons/TableCell'
import GroupsDetails from './GroupsDetails'

import { OPERACIONES_GRUPOS, VALUES } from 'utils/constants'
import { useHasOperation } from 'hooks/useHasOperation'


const GroupTable = ({ groups, order, searchCallback, onEdit, cleanCallback, isSearch }) => {
   const [rowSelected, setRowSelected] = useState()
   const editRole = useHasOperation(OPERACIONES_GRUPOS.EDITAR)
   const enableDetailsButton = useHasOperation(OPERACIONES_GRUPOS.VER_USUARIOS)
   const enableKey = useHasOperation(OPERACIONES_GRUPOS.VER_CODIGO)

   const columns = [
      {
         title: 'NOMBRE GRUPO',
         field: 'name',
         align: 'center',
         sorting: !!isSearch,
         customSort: () => 0,
         defaultSort: order,
         render: rowData => <TableCell text={rowData?.name} />
      },
      {
         title: 'DESCRIPCIÓN GRUPO',
         field: 'description',
         align: 'center',
         sorting: false,
         render: rowData => <TableCell text={rowData?.description} />
      },
      {
         title: 'ESTADO GRUPO',
         field: 'status',
         align: 'center',
         sorting: false,
         render: rowData => (rowData?.status === 'A' ? <Active /> : <Inactive />)
      },
      {
         title: 'VIGENCIA INICIAL',
         field: 'initialDate',
         sorting: false,
         align: 'center'
      },
      {
         title: 'VIGENCIA FINAL',
         field: 'finalDate',
         sorting: false,
         align: 'center'
      },
      {
         title: 'DOMINIO',
         field: 'domain',
         sorting: false,
         align: 'center',
         render: rowData => VALUES.DOMAIN_OPTIONS.find(option => option.value === rowData.domain).label
      },
      {
         title: 'FECHA REGISTRO',
         field: 'createdDate',
         sorting: false,
         align: 'center'
      },
      {
         title: 'USUARIO REGISTRO',
         field: 'createdBy',
         sorting: false,
         align: 'center'
      }
   ]

   const customActions = [
      editRole && {
         icon: 'edit',
         tooltip: 'Editar',
         onClick: (e, rowData) => {
            onEdit(rowData)
         }
      },
      enableDetailsButton && {
         icon: 'groups',
         tooltip: 'Ver usuarios del grupo',
         onClick: (e, rowData) => {
            setRowSelected(rowData)
         }
      }
   ]

   return (
      <>
         <ResultsTable
            columns={columns}
            tableData={groups}
            isSearch={isSearch}
            searchCallback={searchCallback}
            cleanCallback={cleanCallback}
            actionEdit={onEdit}
            customActions={customActions}
            order={order}
            enableKey={enableKey}
         />
         <GroupsDetails group={rowSelected} onClose={setRowSelected} />
      </>
   )
}

export default memo(GroupTable)
